module.exports = __webpack_public_path__ + "static/img/wlwwg.96cd8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wlwwg.png
// module id = GTOQ
// module chunks = 0